// Current set of pressed keys
export const pressed: Set<string> = new Set()
